import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "grid ml-0 mr-1 search-panel" }
const _hoisted_3 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_4 = { class: "flex flex-auto p-input-icon-left p-input-icon-right ml-1 mt-1" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = { class: "flex ml-4 mr-4" }
const _hoisted_7 = { class: "grid ml-0 mr-1 search-panel" }
const _hoisted_8 = { class: "flex align-items-center" }
const _hoisted_9 = { class: "flex align-items-center" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = { class: "flex align-items-center" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = {
  class: "flex align-items-center",
  style: {"margin-left":"auto"}
}
const _hoisted_16 = {
  key: 0,
  class: "pi pi-lock",
  style: {"font-size":"1.75rem"}
}
const _hoisted_17 = {
  key: 1,
  class: "pi pi-lock-open",
  style: {"font-size":"1.75rem"}
}
const _hoisted_18 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "clear" }
const _hoisted_21 = { class: "clear" }
const _hoisted_22 = { class: "clear" }
const _hoisted_23 = {
  key: 0,
  class: "clear"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "clear" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "clear" }
const _hoisted_28 = { class: "clear" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 0,
  class: "flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_ContactDetailsPopup = _resolveComponent("ContactDetailsPopup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "pi pi-users" }, null, -1)),
          _createVNode(_component_InputText, {
            modelValue: _ctx.query.keywords,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.keywords) = $event)),
            placeholder: "Keywords..",
            onInput: _ctx.onKeywordsChanged,
            onKeyup: _withKeys(_ctx.onKeywordsChanged, ["enter"])
          }, null, 8, ["modelValue", "onInput", "onKeyup"]),
          _cache[22] || (_cache[22] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[23] || (_cache[23] = _createElementVNode("i", { class: "pi pi-globe" }, null, -1)),
          _createVNode(_component_InputText, {
            modelValue: _ctx.query.city,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.city) = $event)),
            placeholder: "Location..",
            onInput: _ctx.onKeywordsChanged,
            onKeyup: _withKeys(_ctx.onKeywordsChanged, ["enter"])
          }, null, 8, ["modelValue", "onInput", "onKeyup"]),
          _cache[24] || (_cache[24] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("a", {
              class: _normalizeClass(["css-image island north-island", _ctx.onlyNorthIsland ? 'north-island-icon':'north-island-disabled-icon']),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.displayNorthIslandOnly && _ctx.displayNorthIslandOnly(...args)))
            }, null, 2), [
              [
                _directive_tooltip,
                'Show companies operating in North Island',
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createElementVNode("a", {
              class: _normalizeClass(["css-image island south-island", _ctx.onlySouthIsland ? 'south-island-icon':'south-island-disabled-icon']),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.displaySouthIslandOnly && _ctx.displaySouthIslandOnly(...args)))
            }, null, 2), [
              [
                _directive_tooltip,
                'Show companies operating in South Island',
                void 0,
                { top: true }
              ]
            ])
          ]),
          _withDirectives(_createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportContacts && _ctx.exportContacts(...args))),
            class: "css-image excel-icon mt-1"
          }, null, 512), [
            [
              _directive_tooltip,
              'Export to Excel',
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.activeContactsOnly,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeContactsOnly) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.activeContactsOnly = !_ctx.activeContactsOnly; _ctx.onQueryChanged()})
          }, "Only active")
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.query.includeCustomers,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query.includeCustomers) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.query.includeCustomers = !_ctx.query.includeCustomers; _ctx.onQueryChanged()})
          }, "Customers")
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.query.includeSuppliers,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.query.includeSuppliers) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.query.includeSuppliers = !_ctx.query.includeSuppliers; _ctx.onQueryChanged()})
          }, "Suppliers")
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.query.includeOwners,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.query.includeOwners) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.query.includeOwners = !_ctx.query.includeOwners; _ctx.onQueryChanged()})
          }, "Owners")
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.query.includeSiteContacts,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.query.includeSiteContacts) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.query.includeSiteContacts = !_ctx.query.includeSiteContacts; _ctx.onQueryChanged()})
          }, "Site contacts")
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.query.includeContactsWithoutEmail,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.query.includeContactsWithoutEmail) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.query.includeContactsWithoutEmail = !_ctx.query.includeContactsWithoutEmail; _ctx.onQueryChanged()})
          }, "Missing emails")
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.allowDuplicateEmails,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.allowDuplicateEmails) = $event)),
            class: "mr-1 mt-1",
            onChange: _ctx.onQueryChanged
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("a", {
            class: "mr-4 mt-1",
            onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.allowDuplicateEmails = !_ctx.allowDuplicateEmails; _ctx.onQueryChanged()})
          }, "Duplicate emails")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", {
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleContactsEditMode && _ctx.toggleContactsEditMode(...args)))
          }, [
            (!_ctx.isEditModeEnabled)
              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
              : _createCommentVNode("", true),
            (_ctx.isEditModeEnabled)
              ? (_openBlock(), _createElementBlock("i", _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_DataTable, {
              stripedRows: "",
              class: _normalizeClass(['p-datatable-sm', { 'mailing-list-datatable': _ctx.isEditModeEnabled }]),
              scrollHeight: "flex",
              responsiveLayout: "scroll",
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
              value: _ctx.contacts,
              paginator: true,
              rows: 100,
              scrollable: true,
              rowClass: _ctx.rowClass,
              paginatorTemplate: _ctx.paginatorTemplate,
              rowsPerPageOptions: [10,20,50,100,200]
            }, {
              default: _withCtx(() => [
                (!_ctx.isEditModeEnabled)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      field: "displayName",
                      header: "Contact",
                      class: "flex-wrap"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", {
                          class: "clear",
                          onClick: ($event: any) => (_ctx.onContactClick(data))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ 'compass-red': !!data.email && _ctx.isActive(data), 'cursor-pointer': !!data.email})
                          }, _toDisplayString(data.displayName || '-'), 3),
                          (!data.isActive)
                            ? (_openBlock(), _createBlock(_component_Badge, {
                                key: 0,
                                class: "small-grey-badge ml-1",
                                value: "inactive"
                              }))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_19)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditModeEnabled)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 1,
                      field: "firstName",
                      header: "First name",
                      class: "flex-wrap flex-grow"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_InputText, {
                            modelValue: data.firstName,
                            "onUpdate:modelValue": ($event: any) => ((data.firstName) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditModeEnabled)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 2,
                      field: "lastName",
                      header: "Last name",
                      class: "flex-wrap flex-grow"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_InputText, {
                            modelValue: data.lastName,
                            "onUpdate:modelValue": ($event: any) => ((data.lastName) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditModeEnabled && _ctx.windowWidth >= 1200)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 3,
                      field: "jobTitle",
                      header: "Job title",
                      class: "flex-wrap flex-grow"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_InputText, {
                            modelValue: data.jobTitle,
                            "onUpdate:modelValue": ($event: any) => ((data.jobTitle) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth >= 1500)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 4,
                      field: "companyName",
                      header: "Company",
                      class: "flex-wrap flex-grow"
                    }, {
                      body: _withCtx(({data}) => [
                        (data.companyId && !data.isCompanyDeleted)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_router_link, {
                                to: !data.isCompanyDeleted ? { name: 'CompanyDetails', params: { companyId: data.companyId } } : null
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(data.companyName), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              (!data.isCompanyActive)
                                ? (_openBlock(), _createBlock(_component_Badge, {
                                    key: 0,
                                    class: "small-grey-badge ml-1",
                                    value: "inactive"
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  field: "mobile",
                  header: "Mobile",
                  class: "flex-wrap flex-grow"
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_25, [
                      (!_ctx.isEditModeEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(data.mobile || '-'), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isEditModeEnabled)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: data.mobile,
                            "onUpdate:modelValue": ($event: any) => ((data.mobile) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.isEditModeEnabled && _ctx.windowWidth >= 1200)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 5,
                      field: "ddi",
                      header: "Phone",
                      class: "flex-wrap flex-grow"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_InputText, {
                            modelValue: data.ddi,
                            "onUpdate:modelValue": ($event: any) => ((data.ddi) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  field: "email",
                  header: "Email",
                  class: "flex-wrap flex-grow"
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_28, [
                      (!_ctx.isEditModeEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(data.email || '-'), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isEditModeEnabled)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: data.email,
                            "onUpdate:modelValue": ($event: any) => ((data.email) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.windowWidth >= 1200 && !_ctx.isEditModeEnabled)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 6,
                      field: "city",
                      header: "Location",
                      class: "flex-wrap"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(data.city || '-') + " ", 1),
                        (data.island == 'NI SI')
                          ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                              key: 0,
                              class: "css-image new-zealand-icon island-badge ml-1"
                            }, null, 512)), [
                              [
                                _directive_tooltip,
                                'Operates in North & South Island',
                                void 0,
                                { top: true }
                              ]
                            ])
                          : (data.island == 'NI')
                            ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                                key: 1,
                                class: "css-image north-island-icon island-badge ml-1"
                              }, null, 512)), [
                                [
                                  _directive_tooltip,
                                  'Operates in North Island',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            : (data.island == 'SI')
                              ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                                  key: 2,
                                  class: "css-image south-island-icon island-badge ml-1"
                                }, null, 512)), [
                                  [
                                    _directive_tooltip,
                                    'Operates in South Island',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditModeEnabled && _ctx.windowWidth >= 992)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 7,
                      field: "delete"
                    }, {
                      body: _withCtx(({data}) => [
                        _createElementVNode("div", {
                          title: _ctx.getTooltipText(data.isCompanyActive, data.isActive)
                        }, [
                          (!_ctx.loading && data.isActive)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                icon: "pi pi-trash",
                                onClick: ($event: any) => (_ctx.archiveContact(data))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!_ctx.loading && !data.isActive)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                icon: "pi pi-refresh",
                                onClick: ($event: any) => (_ctx.restoreContact(data)),
                                disabled: !data.isCompanyActive
                              }, null, 8, ["onClick", "disabled"]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_30)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class", "value", "rowClass", "paginatorTemplate"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isEditModeEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "sticky-button",
                icon: "pi pi-save",
                label: "Save",
                onClick: _ctx.saveContacts,
                disabled: !_ctx.hasChanges
              }, null, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showContactDetailsPopup)
      ? (_openBlock(), _createBlock(_component_ContactDetailsPopup, {
          key: 1,
          selectedContact: _ctx.selectedContact,
          onUpdateshowContactDetailsPopup: _cache[20] || (_cache[20] = ($event: any) => {_ctx.showContactDetailsPopup = $event;})
        }, null, 8, ["selectedContact"]))
      : _createCommentVNode("", true)
  ], 64))
}